import { ONBOARDING_THREAD_ID } from '@/utils/constants';

export const onboardingMessagesFR = {
  'step-0': {
    messages: {
      role: 'ai',
      content: [],
    },
  },
  'step-1': {
    messages: {
      role: 'ai',
      content: [
        {
          id: 'onb-0',
          timestamp: '2024-11-21T06:35:39.224335+00:00',
          role: 'human',
          threadId: ONBOARDING_THREAD_ID,
          content:
            'Quels conducteurs nécessitent un accompagnement en raison d’une note globale moyenne inférieure à 70 au cours du mois dernier, et quelles sont leurs notes ?',
        },
        {
          id: 'onb-1',
          timestamp: '2024-11-21T06:36:09.224354+00:00',
          role: 'ai',
          threadId: ONBOARDING_THREAD_ID,
          data_visualization: {
            default_data_visualization: 'table',
            x_axis: 'Nom du conducteur',
          },
          content:
            'Voici les conducteurs ayant une note globale moyenne inférieure à 70 pour le mois de juin 2026 (du 1er juin 2026 au 30 juin 2026). Cette analyse couvre 12 conducteurs nécessitant un accompagnement.\n\n' +
            '```json\n\n' +
            '{"table": [{"Nom du conducteur": "Lucas Auernhammer", "Note globale moyenne (%)": 23.0}, {"Nom du conducteur": "Christian Scheunemann", "Note globale moyenne (%)": 25.0}, {"Nom du conducteur": "Bruno Ranft", "Note globale moyenne (%)": 26.0}, {"Nom du conducteur": "Ute Meyjohann", "Note globale moyenne (%)": 26.0}, {"Nom du conducteur": "Erhard Brauer", "Note globale moyenne (%)": 28.0}, {"Nom du conducteur": "Margit Br\\u00fcck", "Note globale moyenne (%)": 28.0}, {"Nom du conducteur": "Torsten Mustermann", "Note globale moyenne (%)": 39.0}, {"Nom du conducteur": "Marius Mehl", "Note globale moyenne (%)": 42.0}, {"Nom du conducteur": "Thomas Mustermann", "Note globale moyenne (%)": 43.0}, {"Nom du conducteur": "Bernd M\\u00fcller", "Note globale moyenne (%)": 44.0}, {"Nom du conducteur": "Maik Fleischhauer", "Note globale moyenne (%)": 44.0}, {"Nom du conducteur": "Sabine Lindenmann", "Note globale moyenne (%)": 48.0}]}\n```' +
            '\n\n' +
            '**Conducteurs nécessitant une attention prioritaire (note inférieure à 30) :**\n\n' +
            'Les conducteurs Lucas Auernhammer, Christian Scheunemann, Bruno Ranft, Ute Meyjohann, Erhard Brauer et Margit Brück affichent les notes les plus basses de la flotte, toutes inférieures à 30. Ces conducteurs devraient être prioritaires pour un accompagnement individuel intensif.\n\n' +
            "**Conducteurs avec des marges d'amélioration significatives (note entre 39 et 48) :**\n\n" +
            "Torsten Mustermann, Marius Mehl, Thomas Mustermann, Bernd Müller, Maik Fleischhauer et Sabine Lindenmann présentent des notes comprises entre 39 et 48. Bien qu'ils soient au-dessus du groupe précédent, leurs performances restent nettement en dessous du seuil de 70 et méritent un suivi régulier.\n\n" +
            '**Recommandations :**\n\n' +
            '- Un accompagnement ciblé via le programme **MAN ProfiDrive** ou le **Connected CoDriver** peut aider ces conducteurs à améliorer leur style de conduite et leur efficacité.\n\n' +
            "- Il est conseillé d'analyser les sous-notes (freinage, conduite en roue libre, régulateur de vitesse, excès de vitesse) pour identifier les axes d'amélioration spécifiques à chaque conducteur.",
        },
      ],
    },
  },

  'step-2': {
    messages: {
      role: 'ai',
      content: [
        {
          id: 'onb-2',
          timestamp: '2024-11-21T06:36:39.224360+00:00',
          role: 'human',
          threadId: ONBOARDING_THREAD_ID,
          content: 'Quelle est la raison de la faible note de Bruno Ranft?',
        },
        {
          id: 'onb-3',
          timestamp: '2024-11-21T06:37:09.224366+00:00',
          role: 'ai',
          threadId: ONBOARDING_THREAD_ID,
          data_visualization: {
            default_data_visualization: 'table',
          },
          content:
            'Voici les notes détaillées de Bruno Ranft pour la période du 1er juin 2026 au 30 juin 2026.\n\n' +
            '```json\n\n' +
            '{"table": [{"KPI": "Nom du conducteur", "": "Bruno Ranft"}, {"KPI": "Note globale", "": 26.0}, {"KPI": "Note de roulage en roue libre", "": 20.0}, {"KPI": "Note du comportement de freinage", "": 20.0}, {"KPI": "Note de la p\\u00e9dale d\'acc\\u00e9l\\u00e9rateur", "": 40.0}, {"KPI": "Note d\'utilisation du r\\u00e9gulateur de vitesse", "": 50.0}, {"KPI": "Note d\'exc\\u00e8s de vitesse", "": 0.0}]}\n```' +
            '\n\n' +
            'Les résultats montrent que Bruno Ranft obtient une note globale de 26,0, ce qui le place parmi les conducteurs nécessitant une attention prioritaire.\n\n' +
            "Les points les plus préoccupants sont la note d'excès de vitesse (0,0), la note de roulage en roue libre (20,0) et la note du comportement de freinage (20,0), qui sont particulièrement basses.\n\n" +
            "La note de la pédale d'accélérateur (40,0) et la note d'utilisation du régulateur de vitesse (50,0) sont légèrement meilleures, mais restent bien en dessous d'un niveau satisfaisant.\n\n" +
            'Pour améliorer ces performances, un accompagnement individuel via le programme **MAN ProfiDrive** ou le **Connected CoDriver** est fortement recommandé, en ciblant notamment la gestion de la vitesse, l’anticipation au freinage et l’utilisation de la conduite en roue libre.',
        },
      ],
    },
  },

  'step-3': {
    messages: {
      role: 'ai',
      content: [
        {
          id: 'onb-4',
          timestamp: '2024-11-21T06:37:39.224372+00:00',
          role: 'human',
          threadId: ONBOARDING_THREAD_ID,
          content: 'Comment la performance de freinage est-elle calculée?',
        },
        {
          id: 'onb-5',
          timestamp: '2024-11-21T06:38:09.224378+00:00',
          role: 'ai',
          threadId: ONBOARDING_THREAD_ID,
          content:
            'La performance de freinage est calculée selon deux critères principaux :\n\n' +
            '**1. Rapport frein sans usure / frein de service**\n\n' +
            '- **Note 100 %** : rapport de 5:1 ou plus (frein sans usure vs frein de service) **et** moins de 1 % de la distance totale freinée via le frein de service.\n\n' +
            '- **Note 0 %** : rapport de 0,5:1 ou moins **et** plus de 5,5 % de la distance freinée via le frein de service.\n\n' +
            '**2. Principe général**\n\n' +
            'Plus un conducteur utilise le frein sans usure (frein moteur, ralentisseur) par rapport au frein de service, meilleure est sa note.\n\n' +
            'La distance totale parcourue est également prise en compte dans le calcul.\n\n' +
            'Basé sur les documents suivants :\n\n' +
            '1. [eTGS eTruck Manuel du chauffeur - Page 93](https://fleetassistant-staging.rio.cloud/docs/language=FR/market=all/eTGS_eTruck_Manuel_du_chauffeur.pdf#page=93)\n' +
            '2. [eTGX eTruck Manuel du chauffeur - Page 85](https://fleetassistant-staging.rio.cloud/docs/language=FR/market=all/eTGX_eTruck_Manuel_du_chauffeur.pdf#page=85)\n' +
            '3. [Perform Webinar 1 FR - Page 4](https://fleetassistant-staging.rio.cloud/docs/language=FR/market=all/Perform_Webinar_1_FR.pdf#page=4)\n' +
            '4. [Perform Fahrerbewertung 1 FR - Page 3](https://fleetassistant-staging.rio.cloud/docs/language=FR/market=all/Perform_Fahrerbewertung_1_FR.pdf#page=3)\n' +
            '5. [Perform Webinar 1 FR - Page 6](https://fleetassistant-staging.rio.cloud/docs/language=FR/market=all/Perform_Webinar_1_FR.pdf#page=6)',
        },
      ],
    },
  },

  'step-4': {
    messages: {
      role: 'ai',
      content: [
        {
          id: 'onb-6',
          timestamp: '2024-11-21T06:38:39.224384+00:00',
          role: 'human',
          threadId: ONBOARDING_THREAD_ID,
          content: 'Que peut faire mon conducteur Bruno Ranft, qui a une faible note de freinage, pour s’améliorer?',
        },
        {
          id: 'onb-7',
          timestamp: '2024-11-21T06:39:09.224403+00:00',
          role: 'ai',
          threadId: ONBOARDING_THREAD_ID,
          data_visualization: {
            default_data_visualization: 'table',
          },
          content:
            "Pour la période du 2 juin 2026 au 2 juillet 2026, Bruno Ranft affiche une note de comportement de freinage de 20,0 sur 100, ce qui est significativement en dessous du seuil optimal. Voici ce qu'il peut faire concrètement pour s'améliorer :\n\n" +
            '- **KPI** Nom du conducteur: Bruno Ranft\n' +
            '- **KPI** Note du comportement de freinage: 20.0\n\n' +
            '## Comprendre la note de freinage\n\n' +
            'Comme expliqué dans les matériaux de formation MAN, la note de freinage est calculée selon le rapport entre le frein sans usure (frein moteur, ralentisseur) et le frein de service :\n\n' +
            '- **Note 100 %** : rapport de 5:1 ou plus en faveur du frein sans usure, et moins de 1 % de la distance freinée via le frein de service.\n' +
            '- **Note 0 %** : rapport de 0,5:1 ou moins, et plus de 5,5 % de la distance freinée via le frein de service.\n\n' +
            'Avec 20,0 points, Bruno Ranft utilise très probablement le frein de service de manière excessive par rapport aux systèmes de freinage sans usure.\n\n' +
            "## Actions concrètes pour s'améliorer\n\n" +
            '**1. Privilégier le ralentisseur et le frein moteur**\n' +
            '- Dès que la situation de circulation le permet, Bruno Ranft doit utiliser le ralentisseur ou le frein moteur au lieu du frein de service.\n' +
            '- Ces systèmes de freinage sans usure permettent de ralentir le véhicule efficacement tout en préservant les plaquettes de frein et en améliorant directement la note.\n\n' +
            '**2. Adopter une conduite anticipative**\n' +
            "- Anticiper les ralentissements, les virages et les arrêts bien à l'avance afin de lever le pied de l'accélérateur tôt et laisser le frein moteur agir progressivement.\n" +
            '- Éviter les freinages brusques et tardifs qui obligent à recourir au frein de service.\n' +
            '- Observer la circulation loin devant pour adapter la vitesse en douceur.\n\n' +
            '**3. Réduire les freinages et accélérations alternés**\n' +
            '- Les freinages et accélérations brusques et répétés dégradent fortement la note. Bruno Ranft doit viser une conduite fluide et régulière.\n\n' +
            '**4. Respecter les limitations de vitesse**\n' +
            "- Une vitesse adaptée réduit la nécessité de freinages d'urgence et contribue à une meilleure gestion globale du freinage.\n\n" +
            '**5. Utiliser correctement le frein de finisseur (si équipé)**\n' +
            "- En cas d'arrêt complet nécessaire, utiliser le frein de finisseur selon la procédure prévue (bouton dédié + sélecteur rotatif pour ajuster la pression), afin de limiter l'usure du frein de service.\n\n" +
            '## Objectif à atteindre\n\n' +
            "Pour passer d'une note de 20,0 à une note satisfaisante (au-delà de 60), Bruno Ranft doit viser un rapport frein sans usure / frein de service d'au moins 3:1, avec une part du frein de service inférieure à 3 % de la distance freinée totale. Une participation au programme **MAN ProfiDrive** peut également l'aider à intégrer ces bonnes pratiques de manière durable grâce à un coaching personnalisé.\n\n" +
            'Basé sur les documents suivants :\n\n' +
            '1. [Perform Webinar 1 FR - Page 5](https://fleetassistant-staging.rio.cloud/docs/language=FR/market=all/Perform_Webinar_1_FR.pdf#page=5)\n' +
            '2. [eTGS eTruck Manuel du chauffeur - Page 93](https://fleetassistant-staging.rio.cloud/docs/language=FR/market=all/eTGS_eTruck_Manuel_du_chauffeur.pdf#page=93)\n' +
            '3. [eTGX eTruck Manuel du chauffeur - Page 85](https://fleetassistant-staging.rio.cloud/docs/language=FR/market=all/eTGX_eTruck_Manuel_du_chauffeur.pdf#page=85)\n' +
            '4. [Perform Fahrerbewertung 1 FR - Page 3](https://fleetassistant-staging.rio.cloud/docs/language=FR/market=all/Perform_Fahrerbewertung_1_FR.pdf#page=3)\n' +
            '5. [TGX Manuel du chauffeur - Page 644](https://fleetassistant-staging.rio.cloud/docs/language=FR/market=all/TGX_Manuel_du_chauffeur.pdf#page=644)',
        },
      ],
    },
  },
};
